import React from 'react'
import * as wjGrid from '@grapecity/wijmo.react.grid';
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import '../../../static/css/QAListResult.css'
import '@grapecity/wijmo.styles/wijmo.css'
import { typeUncontract } from '../../../api/helpline/mikeiyaku'
import { Typography } from '@material-ui/core';

interface Prop {
  uncontract: typeUncontract[] | undefined,
  handleClickUser: (usercd: string) => void,
}

const UncontractListTable: React.FC<Prop> = (props) => {
  const { uncontract, handleClickUser } = props

  return (
    <React.Fragment>
      {uncontract?.length !== 0 ? (
        <wjGrid.FlexGrid isReadOnly={true} selectionMode="None" autoRowHeights={true} headersVisibility="Column" itemsSource={uncontract} >
          <wjGrid.FlexGridColumn binding="userCd" header="ユーザーCD" width={100} wordWrap={true} cellTemplate={CellMaker.makeButton({
            click: (event: any, ctx) => handleClickUser(ctx.item.userCd)
          })}></wjGrid.FlexGridColumn>
          <wjGrid.FlexGridColumn binding="userNameSyllabary" header="会社名カナ" width={100} align="center" wordWrap={true}></wjGrid.FlexGridColumn>
          <wjGrid.FlexGridColumn binding="userName" header="会社名" width='*' wordWrap={true}></wjGrid.FlexGridColumn>
        </wjGrid.FlexGrid >
      ) : <Typography variant="h6" align='center'>該当する未契約顧客はいません</Typography>}
    </React.Fragment>
  )
}

export default UncontractListTable
